import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const Team = (props) => {
  const data = useStaticQuery(graphql`
    query {
      team: file(
        relativePath: {
          eq: "components/pages/HiringPage/Sections/AdvantagesSection/images/team.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 618, maxHeight: 445, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.team.childImageSharp.fluid} {...props} />
}

export default Team
